import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getOnboardingDetails, onboardingQuestions, setDataForStates, setOnboardingData } from "../../shared/_services/common.services";
import { useDispatch } from "react-redux";
import { setSkipModalData } from "../../redux/onboardingReducer";
import Loader from "../Loader";
import Emergencysavings from "../../assets/images/Emergencysavings2.0.svg";
import Shorttermgoals from "../../assets/images/Short-termgoals2.0.svg";
import Managingbills from "../../assets/images/Managingbills2.0.svg";
import Creditscorehelp from "../../assets/images/Creditscorehelp2.0.svg";
import Retirement from "../../assets/images/Retirement2.0.svg";
import Buyingahome from "../../assets/images/Buyingahome2.0.svg";
import Savingforkids from "../../assets/images/Savingforkids’education2.0.svg";
import Managingold401ks from "../../assets/images/Managingold401(k)s2.0.svg";
import Estatelegacyplanning from "../../assets/images/Estate/legacyplanning2.0.svg";
import Planningformajorlifechanges from "../../assets/images/Planningformajorlifechanges2.0.svg";
import AIChatBot from "./AIChatBot";

const optionIcons = {
  emergencysavings: Emergencysavings,
  shorttermgoals: Shorttermgoals,
  managingbills: Managingbills,
  creditscorehelp: Creditscorehelp,
  retirement: Retirement,
  buyingahome: Buyingahome,
  savingforkidseducation: Savingforkids,
  managingold401ks: Managingold401ks,
  estatelegacyplanning: Estatelegacyplanning,
  planningformajorlifechanges: Planningformajorlifechanges,
};

function extractOnboardingRecord(detailsResponse) {
  if (Array.isArray(detailsResponse?.data?.data)) {
    return detailsResponse.data.data[0];
  }
  if (detailsResponse?.data?.error) {
    return [];
  }
  return null;
}

async function loadPrefillForQuestion(question) {
  const detailsResponse = await getOnboardingDetails(question?._id);
  if (detailsResponse?.status !== 200) {
    return null;
  }

  const onboardingRecord = extractOnboardingRecord(detailsResponse);
  if (!onboardingRecord) {
    return null;
  }

  const stateData = setDataForStates(question, onboardingRecord, false);
  return {
    selectedData: stateData?.selectedData || [],
    other: detailsResponse?.data?.data?.[0]?.others || "",
  };
}

async function applyPrefillForQuestion({
  questionResponse,
  setSelectedOptions,
  setOtherValue,
  onHasSelections,
}) {
  if (questionResponse?.status !== 200) {
    return;
  }

  const question = questionResponse?.data?.[0];
  const prefillData = await loadPrefillForQuestion(question);
  if (!prefillData) {
    return;
  }

  setOtherValue(prefillData.other);
  if (prefillData.selectedData.length > 0) {
    setSelectedOptions(prefillData.selectedData);
    onHasSelections();
  }
}


const QuestionThree = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [selectedOption, setSelectedOption] = useState("");
  const [selectedShortTermOptions, setSelectedShortTermOptions] = useState([]);
  const [selectedLongTermOptions, setSelectedLongTermOptions] = useState([]);
  const [allQuestions, setAllQuestions] = useState([]);
  const isFromUserQuestionnaire = location?.state?.fromUserQuestionnaire;
  const [showLoaderTwo, setShowLoaderTwo] = useState(false);
  const [shortTermOther, setShortTermOther] = useState("");
  const [longTermOther, setLongTermOther] = useState("");


  const checkAndFillDataForQuesTwo = async () => {
    setShowLoaderTwo(true);

    const questions1 = await onboardingQuestions("Short-term");
    const questions2 = await onboardingQuestions("Long-term");
    // #69: an API failure leaves `.data` undefined — indexing into it here
    // (`questions1?.data[0]`) threw inside this async loader, after
    // setShowLoaderTwo(true) and before the setShowLoaderTwo(false) below, so
    // the unhandled rejection left the loader spinning forever. Optional
    // chaining through the index avoids the throw.
    let temp = [];
    temp[0] = questions1?.data?.[0];
    temp[1] = questions2?.data?.[0];
    setAllQuestions(temp);

    await applyPrefillForQuestion({
      questionResponse: questions1,
      setSelectedOptions: setSelectedShortTermOptions,
      setOtherValue: setShortTermOther,
      onHasSelections: () => {
        if (isFromUserQuestionnaire && location.state?.option) {
          setSelectedOption(location.state.option);
          return;
        }
        setSelectedOption(questions1?.data?.[0]?.questionName);
      },
    });

    await applyPrefillForQuestion({
      questionResponse: questions2,
      setSelectedOptions: setSelectedLongTermOptions,
      setOtherValue: setLongTermOther,
      onHasSelections: () => {
        setSelectedOption(questions2?.data?.[0]?.questionName);
      },
    });

    setShowLoaderTwo(false);
  };

  const handleNextQuestion = async () => {
    const isShortTermTab = selectedOption === allQuestions[0]?.questionName;
    const isLongTermTab = selectedOption === allQuestions[1]?.questionName;
    const hasSelectionsForActiveTab =
      (isShortTermTab && selectedShortTermOptions.length > 0) ||
      (isLongTermTab && selectedLongTermOptions.length > 0);

    if (selectedOption && hasSelectionsForActiveTab) {
      setShowLoaderTwo(true);
      if (isFromUserQuestionnaire) {
        await apiCall();
        navigate('/questionnaire');
      } else {
        await apiCall();
        setShowLoaderTwo(false);
        navigate('/q4');
      }
    } else {
      apiCall();
      dispatch(setSkipModalData(true)); // Show modal if no options are selected
    }
  };


  const apiCall = async () => {
    let currentUser = JSON.parse(localStorage.getItem("currentUser"));

    // Prepare selected data for both short-term and long-term options (may be empty arrays)
    let shortTermBody = {
      clientId: currentUser?.user?._id,
      questionId: allQuestions[0]?._id,
      selectedOptions: selectedShortTermOptions.map(data => ({ name: data, value: "" })),
      others: shortTermOther
    };
    await setOnboardingData(shortTermBody); // Send short-term options (empty if none selected)

    let longTermBody = {
      clientId: currentUser?.user?._id,
      questionId: allQuestions[1]?._id,
      selectedOptions: selectedLongTermOptions.map(data => ({ name: data, value: "" })),
      others: longTermOther
    };
    await setOnboardingData(longTermBody); // Send long-term options (empty if none selected)
  };



  const handleOptionSelect = (option) => {
    setSelectedOption(option);
  };

  const toggleOption = (option, isShortTerm) => {
    const selectedOptions = isShortTerm
      ? [...selectedShortTermOptions]
      : [...selectedLongTermOptions];

    if (selectedOptions.includes(option)) {
      const index = selectedOptions.indexOf(option);
      selectedOptions.splice(index, 1);
    } else {
      selectedOptions.push(option);
    }

    if (isShortTerm) {
      setSelectedShortTermOptions(selectedOptions);
    } else {
      setSelectedLongTermOptions(selectedOptions);
    }
  };


  const handleSelectAll = () => {
    if (selectedOption === allQuestions[0]?.questionName) {
      const allShortTermOptions = allQuestions[0]?.options || [];
      setSelectedShortTermOptions(allShortTermOptions);
    } else if (selectedOption === allQuestions[1]?.questionName) {
      const allLongTermOptions = allQuestions[1]?.options || [];
      setSelectedLongTermOptions(allLongTermOptions);
    }
  };

  useEffect(() => {
    checkAndFillDataForQuesTwo();
  }, []); // eslint-disable-line


  const normalizeKey = (str = "") =>
  str
    .toLowerCase()
    .replace(/[^a-z0-9]/g, "");


  return (
    <>
      {showLoaderTwo ? (
        <Loader />
      ) : (
        <div className="question-set">
          <div className="onboaring-quesn justify-content-between d-flex place-items-center">
            <h2>
              <span>Q3</span> 
              <div>What kind of planning support would be helpful?
                 <br/>
              <p>No fancy terms — just choose what fits your life. Choose all that apply.</p></div>
            </h2>
            {!isFromUserQuestionnaire && (
              <button
                type="button"
                className="as-btn-secondary"
                onClick={() => { navigate('/dashboard') }}
              >
                Continue Later</button>)}
          </div>

          <div className="onboarding-label mb-3">
            You are looking for guidance with
          </div>

          <div className="onb-signle-select mb-4">
            <div
              className={`onb-single-select-option ${selectedOption === allQuestions[0]?.questionName ? "if_selected" : ""}`}
              onClick={() => handleOptionSelect(allQuestions[0]?.questionName)}
            >
              {allQuestions[0]?.questionName}
              {selectedShortTermOptions.length > 0 && (
                <span className="option-count-circle">{selectedShortTermOptions?.length}</span>
              )}
            </div>
            <div
              className={`onb-single-select-option ${selectedOption === allQuestions[1]?.questionName ? "if_selected" : ""}`}
              onClick={() => handleOptionSelect(allQuestions[1]?.questionName)}
            >
              {allQuestions[1]?.questionName}
              {selectedLongTermOptions.length > 0 && (
                <span className="option-count-circle">{selectedLongTermOptions.length}</span>
              )}
            </div>
          </div>

          {selectedOption && (
            <>
              {selectedOption === allQuestions[0]?.questionName && (
                <div>
                  <div className="selected option d-flex justify-content-between mt-1">
                    <div className="onboarding-label mb-4">Select {selectedOption}</div>
                    <a className="onboarding-label mb-4 cursor-pointer" href="#" onClick={handleSelectAll}>Select All</a>
                  </div>

                  <div className="short-term-multi-select">
                    {allQuestions[0]?.options?.map((option) => (
                      <div
                        key={option}
                        className={`short-term-multi-select-option ${selectedShortTermOptions.includes(option) ? "if_selected" : ""} ${option.replace(/[\s()]+/g, "")}`}
                        onClick={() => toggleOption(option, true)}
                      >
                        <span>{option}</span>
                        <img alt="short term icon" src={optionIcons[normalizeKey(option)]} />
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {selectedOption === allQuestions[1]?.questionName && (
                <div>
                  <div className="selected option d-flex justify-content-between">
                    <div className="onboarding-label mb-4">Select {selectedOption}</div>
                    <a className="onboarding-label mb-4 cursor-pointer" onClick={handleSelectAll}>Select All</a>
                  </div>

                  <div className="short-term-multi-select">
                    {allQuestions[1]?.options?.map((option) => (
                      <div
                        key={option}
                        className={`short-term-multi-select-option ${selectedLongTermOptions.includes(option) ? "if_selected" : ""} ${option.replace(/\s+/g, "")}`}
                        onClick={() => toggleOption(option, false)}
                      >
                        <span>{option}</span>
                        <img alt="short term icon" src={optionIcons[normalizeKey(option)]} />
                      </div>
                    ))}
                  </div>
                </div>
              )}

            </>
          )}

        </div>)}
      {!showLoaderTwo && (
        <div className="onboarding-footer">
          {/* Conditionally show textarea based on selectedOption */}
          {selectedOption === allQuestions[0]?.questionName && (
            <div className="common-other-textbox mt-3 mb-3">
              <textarea
                name="shortTermOther"
                id="shortTermOther"
                placeholder="Other (Short Term)"
                value={shortTermOther}
                onChange={(e) => setShortTermOther(e.target.value)}
              />
            </div>
          )}

          {selectedOption === allQuestions[1]?.questionName && (
            <div className="common-other-textbox mt-3 mb-3">
              <textarea
                name="longTermOther"
                id="longTermOther"
                placeholder="Other (Long Term)"
                value={longTermOther}
                onChange={(e) => setLongTermOther(e.target.value)}
              />
            </div>
          )}

          <div className="onboarding-footer-btns">
            <div className="d-flex justify-content-between w-100">
              {isFromUserQuestionnaire ? (
                <>
                  <button
                    type="button"
                    className="as-btn-secondary"
                    onClick={() => {
                      navigate("/questionnaire")
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="as-btn-primary"
                    onClick={handleNextQuestion}
                  >
                    Update
                  </button>
                </>
              ) : (
                <>
                  <button
                    type="button"
                    className="as-btn-secondary"
                    onClick={() => navigate("/q2", { state: { fromQuestionThree: true } })}
                  >
                    ← Your Goals
                  </button>
                  <button
                    type="button"
                    className="as-btn-primary"
                    onClick={handleNextQuestion}
                  >
                   Big Decisions →
                  </button>
                </>
              )}
            </div>
            <AIChatBot
              questionName={selectedOption}
              options={
                selectedOption === allQuestions[0]?.questionName
                  ? allQuestions[0]?.options
                  : allQuestions[1]?.options
              }
              firstMsg="I’m here to help you think about your financial planning timeframe. Are you focused on short-term goals (1–5 years) or long-term planning (5+ years)?"
            />

          </div>
        </div>
      )}
    </>
  );
};

export default QuestionThree;
